<div class="background" style="background-color: red ;" fxLayout="column" fxFlexFill>
    <div style="background-color: blue;" fxLayout="row">
        <div style="background-color: rgb(194, 194, 250);" fxLayout="row" fxLayoutAlign="center center" fxFlex="50%">
            <div fxLayout="column" style="background-color: gray;" fxLayoutAlign="center center">
                <div fxFlexAlign="start">Account Name</div>                
                <mat-form-field id="account-name" class="user-id-field" appearance="outline" fxFlex="300">
                    <input id="name-id-field" matInput formControlName="nameFormControl" [value]="accountName">
                </mat-form-field>
            </div>
        </div>
        <div style="background-color: green;" fxLayout="row" fxLayoutAlign="center center" fxFlex="50%">
            <div fxLayout="column" style="background-color: gray;" fxLayoutAlign="center center">
                <div fxFlexAlign="start">Birth Date:</div>
                <mat-form-field class="birthday-id-field" appearance="outline">
                    <input id="birthday-id-field" matInput formControlName="birthdayFormControl">
                    <!-- <mat-error *ngIf="contactUsFormHasError('nameFormControl', 'required')">
                Name is required.
            </mat-error>
            <mat-error *ngIf="contactUsFormHasError('nameFormControl', 'maxlength')">
                Name is too long.
            </mat-error> -->
                </mat-form-field>
            </div>
        </div>
    </div>
    <div style="background-color: orange;" fxLayout="row" fxLayoutAlign="center end" fxFlex="100%">
        <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="150px">
            <!-- <button class="green-button" form="contact-us-form" type="submit" [disabled]="contactUsFormGroup.invalid"
                (click)="sendContactUsInformation()" fxLayoutAlign="center center">
                Request Callback
            </button> -->
            <button class="green-button" type="submit" [disabled]="true">
                Save Changes
            </button>
        </div>
        <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="150px">
            <!-- <button class="green-button" form="contact-us-form" type="submit" [disabled]="contactUsFormGroup.invalid"
                (click)="sendContactUsInformation()" fxLayoutAlign="center center">
                Request Callback
            </button> -->
            <button class="green-button" type="submit">
                Cancel
            </button>
        </div>
    </div>
</div>